const cookie	=	require('react-cookies');
let	adminType	=	cookie.load('adminType');

let adminNav	=	{};
if(adminType == "admin") {
	adminNav = {
		items: [
			{
				name: 'Dashboard',
				module: 'dashboard',
				url: '/dashboard',
				icon: 'icon-chart',
				badge: {
					variant: 'info',
				},
			},
			
			{
				name: 'DA Dashboard',
				module: 'dadashboard',
				url: '/da_dashboard',
				icon: 'icon-chart',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'Sub-Admin',
				module: 'subAdmin',
				url: '/admins',
				icon: 'icon-speedometer',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'Users',
				module: 'users',
				url: '/users',
				icon: 'icon-people',
				badge: {
					variant: 'info',
				},
			},
			{
				name :'InApp',
				module: 'inApp',
				url: '/inapp',
				icon: 'icon-bell',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'Payment Gateway',
				module: 'PaymentGateway',
				url: '/payment-gateway',
				icon: 'icon-people',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'Withdraw',
				module: 'Withdraw',
				url: '/withdraw',
				icon: 'icon-people',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'Diposite',
				module: 'Diposite',
				url: '/diposite',
				icon: 'icon-people',
				badge: {
					variant: 'info',
				},
			},
			

			

			// {
			// 	name: 'Revenue Comm.',
			// 	module: 'revenue',
			// 	url: '/revenue-list',
			// 	icon: 'icon-people',
			// 	badge: {
			// 		variant: 'info',
			// 	},
			// },
			{
				name: 'Revenue Comm',
				module: 'revenue',
				url: '/revenue-list',
				icon: 'icon-nav-icon icon-star',
				badge: {
					variant: 'info',
				},
				children: [
					{
						name: 'Sports Revenue',
						url: '/revenue-list',
						icon: 'icon-star',
					},
					{
						name: 'Prediction Revenue',
						url: '/revenue-list-prediction',
						icon: 'icon-star',
					},
					{
						name: 'Trade Revenue',
						url: '/revenue-list-trade',
						icon: 'icon-star',
					}
				]
			},
			{
				name: 'Contest Categories',
				module: 'contestCategories',
				url: '/contestcategory',
				icon: 'icon-layers',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'Contests',
				module: 'contests',
				url: '/contests',
				icon: 'icon-nav-icon icon-trophy',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'Other Games Contests',
				module: 'otherGamesContests',
				url: '/other-games-contests',
				icon: 'icon-nav-icon icon-trophy',
				badge: {
					variant: 'info',
				},
			},
			
			{
				name: 'Contests Schedule',
				module: 'contestsSchedule',
				url: '/contests_schedule',
				icon: 'icon-nav-icon icon-star',
				badge: {
					variant: 'info',
				},
				children: [
					{
						name: 'Cricket',
						url: '/contests_schedule',
						icon: 'icon-star',
					},
					{
						name: 'Football',
						url: '/football_contests_schedule',
						icon: 'icon-star',
					},
					{
						name: 'Kabaddi',
						url: '/kabaddi_contests_schedule',
						icon: 'icon-star',
					},
					// {
					// 	name: 'Live Fantasy',
					// 	url: '/live-fantasy-contests-schedule',
					// 	icon: 'icon-star',
					// },
					
					// {
					// 	name: 'Player Exchnage',
					// 	url: '/player-exchnage',
					// 	icon: 'icon-star',
					// },
					// {
					// 	name: 'Player Exchnage Foootball',
					// 	url: '/football-player-exchnage',
					// 	icon: 'icon-star',
					// },
					// {
					// 	name: 'Player Exchnage Kabaddi',
					// 	url: '/kabaddi-player-exchnage',
					// 	icon: 'icon-star',
					// },
					// {
					// 	name: 'Live Exchange',
					// 	url: '/live-exchange',
					// 	icon: 'icon-star',
					// },
					// {
					// 	name: 'Live Exchange Foootball',
					// 	url: '/football-Live-exchange',
					// 	icon: 'icon-star',
					// },
					// {
					// 	name: 'Live Exchange Kabaddi',
					// 	url: '/kabaddi-Live-exchange',
					// 	icon: 'icon-star',
					// }
				]
			},

			
			
			{
				name: 'Other Game',
				module: 'otherGame',
				url: '/other-games',
				icon: 'icon-nav-icon icon-game',
				badge: {
					variant: 'info',
				},
				children: [
					{
					  name: 'Match List',
					  url: '/other-games',
					  icon: 'icon-star',
					},
					{
					  name: 'Transaction List',
					  url: '/other-games/transaction-list',
					  icon: 'icon-star',
					},
					{
					  name: 'Revenue Comm.',
					  url: '/other-games/revenue-list',
					  icon: 'icon-star',
					},
					// {
					//   name: 'GST Manager',
					//   url: '/other-games/gst-list',
					//   icon: 'icon-star',
					// },
				]
			},
			
			{
				name: 'Prediction Transaction',
				module: 'PredictionTrasactionTable',
				url: '/prediction_transaction',
				icon: 'icon-nav-icon icon-star',
				badge: {
					variant: 'info',
				},
			},
			
			
			{
				name: 'Wallet Manager',
				module: 'walletManager',
				url: '/wallet/list',
				icon: 'icon-wallet',
				badge: {
					variant: 'info',
				},
			},
	
			// {
			// 	name: 'WithDraw Requests',
			// 	module: 'withdrawRequests',
			// 	url: '/userwithdraw',
			// 	icon: 'fa fa-dollar',
			// 	badge: {
			// 		variant: 'info',
			// 	},
			// 	children: [
			// 		{
			// 			name: "Youtubers",
			// 			url: '/userwithdrawYoutuber/youtuber',
			// 			icon: 'icon-puzzle',
			// 		},
			// 		{
			// 			name: 'Paytm',
			// 			url: '/userwithdrawByPaytm/paytm',
			// 			icon: 'icon-puzzle',
			// 		},
			// 		{
			// 			name: 'Bank',
			// 			url: '/userwithdrawByBank/bank',
			// 			icon: 'icon-puzzle',
			// 		},
			// 		{
			// 			name: 'Instant',
			// 			url: '/userwithdrawByInstant/instant',
			// 			icon: 'icon-puzzle',
			// 		},
			// 		{
			// 			name: 'Above 10K',
			// 			url: '/userwithdrawByAboveTen/aboveten',
			// 			icon: 'icon-puzzle',
			// 		},
			// 		{
			// 			name: '5K - 10K',
			// 			url: '/userwithdrawFiveToTen/fiveToTen',
			// 			icon: 'icon-puzzle',
			// 		},
			// 		{
			// 			name: 'User Instant Withdraw',
			// 			url: '/userwithdrawByInstant/user_instant',
			// 			icon: 'icon-puzzle',
			// 		},
			// 		{
			// 			name: 'Rejected Withdraw',
			// 			url: '/withdraw-rejected',
			// 			icon: 'icon-puzzle',
			// 		},
			// 		{
			// 			name: 'Report',
			// 			url: '/userwithdrawReport/report',
			// 			icon: 'icon-puzzle',
			// 		},
			// 	]
			// },
			
			
			
			{
				name: 'Player Manager',
				module: 'playerManager',
				url: '/playermanager',
				icon: 'icon-target',
				badge: {
					variant: 'info',
				},
				children: [
					{
						name: 'Cricket',
						url: '/playermanagerCricket/1',
						icon: 'icon-target',
					},
					{
						name: 'Football',
						url: '/playermanagerFootball/2',
						icon: 'icon-target',
					},
					{
						name: 'Kabaddi',
						url: '/playermanagerKabaddi/4',
						icon: 'icon-target',
					},
				]
			},
			{
				name: 'Player Manager New',
				module: 'playerManagerNew',
				url: '/playermanager',
				icon: 'icon-target',
				badge: {
					variant: 'info',
				},
				children: [
					{
						name: 'Cricket',
						url: '/newPlayermanagerCricket/1',
						icon: 'icon-target',
					},
					{
						name: 'Football',
						url: '/newPlayermanagerFootball/2',
						icon: 'icon-target',
					},
					{
						name: 'Kabaddi',
						url: '/newPlayermanagerKabaddi/4',
						icon: 'icon-target',
					},
				]
			},
			{
				name: 'Team Manager',
				module: 'teamManager',
				url: '/teammanager',
				icon: 'icon-target',
				badge: {
					variant: 'info',
				},
				children: [
					{
						name: 'Cricket',
						url: '/teammanagerCricket/1',
						icon: 'icon-target',
					},
					{
						name: 'Football',
						url: '/teammanagerFootball/2',
						icon: 'icon-target',
					},
					{
						name: 'Kabaddi',
						url: '/teammanagerKabaddi/4',
						icon: 'icon-target',
					},
				]
			},
	
			// {
			//   name: 'Weekly Leaderboard',
			//   module: 'weeklySeriesManager',
			//   url: '/weeklyLeaderboard',
			//   icon: 'icon-target',
			//   badge: {
			//     variant: 'info',
			//   },
			// },
	
			{
				name: 'Series',
				module: 'seriesManager',
				url: '/series',
				icon: 'icon-target',
				badge: {
					variant: 'info',
				},
				children: [
					{
						name: 'Cricket',
						url: '/seriesCricket/1',
						icon: 'icon-target',
					},
					{
						name: 'Football',
						url: '/seriesFootball/2',
						icon: 'icon-target',
					},
					{
						name: 'Kabaddi',
						url: '/seriesKabaddi/4',
						icon: 'icon-target',
					},
				]
			},
	
			{
				name: 'Series Matches',
				module: 'seriesMatchesManager',
				url: '/series-matches',
				icon: 'icon-target',
				badge: {
					variant: 'info',
				},
				children: [
					{
						name: 'Cricket',
						url: '/series-matches-cricket/1',
						icon: 'icon-target',
					},
					{
						name: 'Football',
						url: '/series-matches-football/2',
						icon: 'icon-target',
					},
					{
						name: 'Kabaddi',
						url: '/series-matches-kabaddi/4',
						icon: 'icon-target',
					},
				]
			},
			{
				name: 'Series Matches New',
				module: 'seriesMatchesManagerNew',
				url: '/series-matches',
				icon: 'icon-target',
				badge: {
					variant: 'info',
				},
				children: [
					{
						name: 'Cricket',
						url: '/series-matches-cricket-new/1',
						icon: 'icon-target',
					},
					{
						name: 'Football',
						url: '/series-matches-football-new/2',
						icon: 'icon-target',
					},
					{
						name: 'Kabaddi',
						url: '/series-matches-kabaddi-new/4',
						icon: 'icon-target',
					},
				]
			},
			{
				name: 'Match Banners',
				module: 'matchBannerManager',
				url: '/match-banners',
				icon: 'icon-target',
				badge: {
					variant: 'info',
				},
				children: [
					{
						name: 'Cricket',
						url: '/match-banners-cricket/1',
						icon: 'icon-target',
					},
					{
						name: 'Football',
						url: '/match-banners-football/2',
						icon: 'icon-target',
					},
					{
						name: 'Kabaddi',
						url: '/match-banners-kabaddi/4',
						icon: 'icon-target',
					},
				]
			},
			{
				name: 'App Banners',
				module: 'matchBannerManager',
				url: '/notification-banner',
				icon: 'icon-bell',
				badge: {
					variant: 'info',
				},
			},

			{
				name: 'Payment Options Setting',
				module: 'paymentOptions',
				url: '/payment-options',
				icon: 'icon-wrench',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'Sport Options Setting',
				module: 'sportOptions',
				url: '/sport-options',
				icon: 'icon-wrench',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'Points System',
				module: 'pointsSystem',
				url: '/points',
				icon: 'icon-speedometer',
				badge: {
					variant: 'info',
				},
			},
			
			
			{
				name: 'Transaction',
				url: '/transaction',
				module: 'transaction',
				icon: 'fa fa-paypal',
				badge: {
					variant: 'info',
				},
			},
			
		],
	};
} else {
	adminNav = {
		items: [
			{
				name: 'Diposite',
				module: 'diposite',
				url: '/diposite',
				icon: 'icon-people',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'Dashboard',
				module: 'dashboard',
				url: '/dashboard',
				icon: 'icon-chart',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'Sub-Admin',
				module: 'subAdmin',
				url: '/admins',
				icon: 'icon-speedometer',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'Users',
				module: 'users',
				url: '/users',
				icon: 'icon-people',
				badge: {
					variant: 'info',
				},
			},
			{
				name :'InApp',
				module: 'inApp',
				url: '/inapp',
				icon: 'icon-bell',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'PaymentGateway',
				module: 'PaymentGateway',
				url: '/payment-gateway',
				icon: 'icon-people',
				badge: {
					variant: 'info',
				},
			},
			
			
			{
				name: 'Revenue Comm.',
				module: 'revenue',
				url: '/revenue-list',
				icon: 'icon-people',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'Contest Categories',
				module: 'contestCategories',
				url: '/contestcategory',
				icon: 'icon-layers',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'Contests',
				module: 'contests',
				url: '/contests',
				icon: 'icon-nav-icon icon-trophy',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'Other Games Contests',
				module: 'otherGamesContests',
				url: '/other-games-contests',
				icon: 'icon-nav-icon icon-trophy',
				badge: {
					variant: 'info',
				},
			},
	
			{
				name: 'Contests Schedule',
				module: 'contestsSchedule',
				url: '/contests_schedule',
				icon: 'icon-nav-icon icon-star',
				badge: {
					variant: 'info',
				},
				children: [
					{
						name: 'Cricket',
						url: '/contests_schedule',
						icon: 'icon-star',
					},
					{
						name: 'Football',
						url: '/football_contests_schedule',
						icon: 'icon-star',
					},
					{
						name: 'Kabaddi',
						url: '/kabaddi_contests_schedule',
						icon: 'icon-star',
					},
					{
						name: 'Live Fantasy',
						url: '/live-fantasy-contests-schedule',
						icon: 'icon-star',
					}
				]
			},
	
			
			{
				name: 'Other Game Match List',
				module: 'otherGame',
				url: '/other-games',
				icon: 'icon-nav-icon icon-star',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'Other Game Transaction List',
				module: 'otherGameTransactionList',
				url: '/other-games/transaction-list',
				icon: 'icon-nav-icon icon-star',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'Other Game Revenue Comm.',
				module: 'otherGameRevenueComm',
				url: '/other-games/revenue-list',
				icon: 'icon-nav-icon icon-star',
				badge: {
					variant: 'info',
				},
			},
			{
				name: 'Other Game GST Manager',
				module: 'otherGameGst',
				url: '/other-games/gst-list',
				icon: 'icon-nav-icon icon-star',
				badge: {
					variant: 'info',
				},
			},
			
			{
				name: 'Prediction Transaction',
				module: 'PredictionTrasactionTable',
				url: '/prediction_transaction',
				icon: 'icon-nav-icon icon-star',
				badge: {
					variant: 'info',
				},
			},

			
			
			
			
			{
				name: 'Player Manager',
				module: 'playerManager',
				url: '/playermanager',
				icon: 'icon-target',
				badge: {
					variant: 'info',
				},
				children: [
					{
						name: 'Cricket',
						url: '/playermanagerCricket/1',
						icon: 'icon-target',
					},
					{
						name: 'Football',
						url: '/playermanagerFootball/2',
						icon: 'icon-target',
					},
					{
						name: 'Kabaddi',
						url: '/playermanagerKabaddi/4',
						icon: 'icon-target',
					},
				]
			},
			{
				name: 'Team Manager',
				module: 'teamManager',
				url: '/teammanager',
				icon: 'icon-target',
				badge: {
					variant: 'info',
				},
				children: [
					{
						name: 'Cricket',
						url: '/teammanagerCricket/1',
						icon: 'icon-target',
					},
					{
						name: 'Football',
						url: '/teammanagerFootball/2',
						icon: 'icon-target',
					},
					{
						name: 'Kabaddi',
						url: '/teammanagerKabaddi/4',
						icon: 'icon-target',
					},
				]
			},
	
			{
				name: 'Series',
				module: 'seriesManager',
				url: '/series',
				icon: 'icon-target',
				badge: {
					variant: 'info',
				},
				children: [
					{
						name: 'Cricket',
						url: '/seriesCricket/1',
						icon: 'icon-target',
					},
					{
						name: 'Football',
						url: '/seriesFootball/2',
						icon: 'icon-target',
					},
					{
						name: 'Kabaddi',
						url: '/seriesKabaddi/4',
						icon: 'icon-target',
					},
				]
			},
	
			{
				name: 'Series Matches',
				module: 'seriesMatchesManager',
				url: '/series-matches',
				icon: 'icon-target',
				badge: {
					variant: 'info',
				},
				children: [
					{
						name: 'Cricket',
						url: '/series-matches-cricket/1',
						icon: 'icon-target',
					},
					{
						name: 'Football',
						url: '/series-matches-football/2',
						icon: 'icon-target',
					},
					{
						name: 'Kabaddi',
						url: '/series-matches-kabaddi/4',
						icon: 'icon-target',
					},
				]
			},
			{
				name: 'Match Banners',
				module: 'matchBannerManager',
				url: '/match-banners',
				icon: 'icon-target',
				badge: {
					variant: 'info',
				},
				children: [
					{
						name: 'Cricket',
						url: '/match-banners-cricket/1',
						icon: 'icon-target',
					},
					{
						name: 'Football',
						url: '/match-banners-football/2',
						icon: 'icon-target',
					},
					{
						name: 'Kabaddi',
						url: '/match-banners-kabaddi/4',
						icon: 'icon-target',
					},
				]
			},
			
			
		
	
			
	
			
			{
				name: 'Points System',
				module: 'pointsSystem',
				url: '/points',
				icon: 'icon-speedometer',
				badge: {
					variant: 'info',
				},
			},
			
			
			
	
			
			
			{
				name: 'Transaction',
				url: '/transaction',
				module: 'transaction',
				icon: 'fa fa-paypal',
				badge: {
					variant: 'info',
				},
			},
			
			
	
		],
	};
}

module.exports = {
	adminNav
};
